import axios from "axios";
import request from "../../components/Helper/request";
const ROOM_LOGIN = "kbport/room/LOGIN";
const KBPORT_LOGIN_REQUEST = "kbport/auth/LOGIN_REQUEST";
const KBPORT_LOGIN_FAIL = "kbport/auth/KBPORT_LOGIN_FAIL";
const KBPORT_LOGIN = "kbport/auth/LOGIN";
const KBPORT_TOKEN = "kbport/auth/KBPORT_TOKEN";
const KBPORT_USER_DATA = "kbport/auth/KBPORT_USER_DATA";
const KBPORT_MEETING_DATA = "kbport/auth/KBPORT_MEETING_DATA";
const KBPORT_ALL_MEETINGS_DATA = "kbport/auth/KBPORT_ALL_MEETINGS_DATA";
const notAuthorized =
  "You are not authorized to access Telehealth, please contact sales@kbport.com";

const kbportLogin = (email, password) => {
  return async function (dispatch) {
    dispatch(loginRequest({ email }));
    return await request
      .postLogin({
        url: "\\Token",
        body: `grant_type=password&username=${encodeURIComponent(
          email
        )}&password=${password}`,
      })
      .then((data) => {
        dispatch(KbportloginSuccess());
        setSession(data.access_token);
      })
      .catch((err) => {
        return dispatch(loginFailure(err));
      });
  };
};

const getMeetingInfo = (roomId) => {
  return function (dispatch) {
    dispatch(meetingData({ isLoading: true }));
    return request
      .get({ url: `\\api//Telehealth//GetMeeting/?meetingName=${roomId}` })
      .then((data) => {
        dispatch(meetingData({ data: data, isLoading: false }));
      })
      .catch((err) =>
        dispatch(meetingData({ error: notAuthorized, isLoading: false }))
      );
  };
};

const getAllMeetings = () => {
  return function (dispatch) {
    dispatch(allMeetingsData({ isLoading: true }));
    return request
      .get({ url: `\\api//Telehealth//GetAllMeetings` })
      .then((data) => {
        dispatch(allMeetingsData({ data: data, isLoading: false }));
      })
      .catch((err) =>
        dispatch(allMeetingsData({ error: notAuthorized, isLoading: false }))
      );
  };
};

const setSession = (access_token) => {
  if (access_token) {
    localStorage.setItem("kbport_access_token", access_token);
    axios.defaults.headers.common["Authorization"] = "bearer " + access_token;
  } else {
    localStorage.removeItem("kbport_access_token");
    delete axios.defaults.headers.common["Authorization"];
  }
};

const logoutKbport = () => {
  return function (dispatch) {
    localStorage.removeItem("kbport_access_token");
    delete axios.defaults.headers.common["Authorization"];
    dispatch(tokenState(false));
  };
};

const handleAuthentication = () => {
  return function (dispatch) {
    let access_token = getAccessToken();
    if (!access_token) {
      dispatch(tokenState(false));
      return;
    }
    setSession(access_token);
    dispatch(tokenState(true));
  };
};

const getUserInfo = () => {
  return function (dispatch) {
    dispatch(userData({ isLoading: true }));
    return request
      .get({ url: "\\api//Telehealth//GetCurrentUser" })
      .then((data) => {
        dispatch(userData({ data: data, isLoading: false }));
      })
      .catch((err) =>
        dispatch(userData({ error: notAuthorized, isLoading: false }))
      );
  };
};

const getAccessToken = () => {
  return window.localStorage.getItem("kbport_access_token");
};

const allMeetingsData = (payload) => ({
  type: KBPORT_ALL_MEETINGS_DATA,
  payload: { allMeetings: payload },
});

const meetingData = (payload) => ({
  type: KBPORT_MEETING_DATA,
  payload: { meetingData: payload },
});

const userData = (payload) => ({
  type: KBPORT_USER_DATA,
  payload: { userData: payload },
});

const loginRequest = ({ roomId, username, secret, adminLogin }) => ({
  type: KBPORT_LOGIN_REQUEST,
  payload: { roomId, username, secret, adminLogin },
});

const KbportloginSuccess = () => ({
  type: KBPORT_LOGIN,
});

const tokenState = (state) => ({
  type: KBPORT_TOKEN,
  payload: { state: state },
});

const loginFailure = (error) => ({
  type: KBPORT_LOGIN_FAIL,
  payload: { error: error },
});

const actionCreators = {
  loginFailure,
  kbportLogin,
  handleAuthentication,
  getUserInfo,
  logoutKbport,
  getMeetingInfo,
  getAllMeetings
};

const actionTypes = {
  ROOM_LOGIN,
  KBPORT_LOGIN_REQUEST,
  KBPORT_LOGIN,
  KBPORT_TOKEN,
  KBPORT_MEETING_DATA,
  KBPORT_ALL_MEETINGS_DATA
};

export const initialState = {
  loggedIn: false,
  loggingIn: false,
  kbportLogin: false,
  userData: null,
  meetingInfo: null,

};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case KBPORT_LOGIN_REQUEST: {
      return { ...payload, loggingIn: true };
    }
    case KBPORT_LOGIN: {
      return { ...state, kbportLogin: true };
    }
    case KBPORT_LOGIN_FAIL: {
      return { ...state, kbportLogin: false, ...payload };
    }
    case KBPORT_USER_DATA: {
      return { ...state, ...payload };
    }
    case KBPORT_MEETING_DATA: {
      return { ...state, ...payload };
    }
    case KBPORT_ALL_MEETINGS_DATA: {
      return { ...state, ...payload };
    }
    case KBPORT_TOKEN: {
      return { ...state, ...payload };
    }

    default:
      return state;
  }
};

export { actionCreators, actionTypes };

export default reducer;
